import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const Item = Form.Item

export default class MyProcessCaseReturn extends Component {

   // 基礎通用參數 ////////////////////////////////////////////// 

    static propTypes = {
        modalform: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        // 將form對象透過modalform()傳遞給父組件
        this.props.modalform(this.fm)
    }

    ////////////////////////////////////////////////////////////       

    render() {
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        label="退案說明"
                        name="RecordDescription"
                        rules={[
                            { required: true, message: '必須輸入說明' },
                        ]}
                    >
                        <Input placeholder='請輸入退案說明' />
                    </Item>
                </Form>
            </div>
        )
    }
}